import _ from "lodash";
import { getPPGradebookProjectGroupStudentsWithProjectsQuery } from "./PPGradebookTableQueries";
import client from "lib/apolloClient/client";

export const getPPGradebookProjectGroupStudentsWithProjectsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPPGradebookProjectGroupStudentsWithProjectsQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writePPGradebookProjectGroupStudentsWithProjectsToCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getPPGradebookProjectGroupStudentsWithProjectsQuery,
      variables,
      data: {
        node: data,
      },
    });
  } catch (e) {
    console.error("Error writing data to cache:", e);
  }
};
